export enum ActivityStatus {
  Active = 'Active',
  Draft = 'Draft',
  Reported = 'Reported',
  Deleted = 'Deleted'
}
